import './DownloadHomeDescription.scss';
import { useBowser } from '../../../../hooks/useBowser';

export const DownloadHomeDescription = () => {
  const { isMobile } = useBowser();

  return (
    <div className="download-home-description">
      <h1 className="download-home-description__title">
        Download the latest version of AirKey
      </h1>
      <p className="download-home-description__text">
        See latest artifacts and additional details using the arrows below.
      </p>
      {isMobile && (
        <p className="download-home-description__mobile-text">
          AirKey software can be downloaded on a desktop device.
        </p>
      )}
    </div>
  );
};
